import link_arrow from 'styles/images/link-arrow.svg';

const ChildrenCheck = ({ guideUrl }) => {
  return (
    <div className='minor-guide'>
      <p className='txt_g'>미성년자 실명인증이 안될 경우 아래의 사이트에서 실명 등록을 먼저 해 주시기 바랍니다.</p>
      <a href={guideUrl} className='btn_link' target='_blank' rel='noreferrer'>
        개인 실명등록 홈페이지 접속
        <img src={link_arrow} className='link-arrow' alt='바로가기' />
      </a>
    </div>
  );
};
export default ChildrenCheck;
